export const tabData = [
  {
    id: 'prospects-ai',
    name: 'Prospects AI',
    default: true,
  },
  {
    id: 'saved-prospects',
    name: 'Saved Prospects',
  },
  {
    id: 'prospects-database',
    name: 'Prospects Database',
  },
]

export const desiredKeywordsMatchRuleOptions = [
  {
    title: '',
    options: ['Any (Broader)', 'All (Specific)', 'None'],
  },
]

export const desiredKeywordsMatchRuleMap = {
  'Any (Broader)': 'anyOf',
  'All (Specific)': 'allOf',
  None: 'noneOf',
}

export const relevancyScoreOptions = [
  {
    title: '',
    options: ['90%', '85%', '80%', '75%', '70%', '65%', '60%', '55%', '50%'],
  },
]

export const ContactStatus = {
  REVEAL_REQUIRED: 'REVEAL_REQUIRED',
  EXTERNAL_REVEAL_REQUIRED: 'EXTERNAL_REVEAL_REQUIRED',
  REVEAL_REQUESTED: 'REVEAL_REQUESTED',
}

export const TAILORED_LEADS_FORM_STORAGE_KEY = 'tailored-leads-form'

export const ERROR_MESSAGES = {
  FETCH_TAILORED_LEADS_FAILED: 'Sorry, we encountered an internal error and couldn’t generate leads for this request.',
  FETCH_LEAD_DETAIL_FAILED: 'Sorry, we encountered an internal error and couldn’t show lead’s details now.',
  FETCH_SAVED_LEADS_FAILED: 'Sorry, we encountered an internal error and couldn’t show saved leads.',
  VIEW_LEAD_FAILED: 'Sorry, we encountered an internal error and couldn’t open lead card now.',
  SAVE_LEAD_FAILED: 'Sorry, we encountered an internal error and couldn’t save this lead.',
  FETCH_CREDIT_RATES_FAILED: 'Sorry, we couldn’t fetch credit rates at the moment. Please refresh and retry.',
  FETCH_CREDIT_BALANCE_FAILED: 'Sorry, we couldn’t retrieve your credit balance. Please try again.',
  FETCH_COUNTRIES_FAILED: 'Sorry, we couldn’t load the list of countries. Please try again shortly.',
  FETCH_FILTER_OPTIONS_FAILED: 'Sorry, we couldn’t load filter options. Please refresh the page and try again.',
  FETCH_DESIRED_INDUSTRIES_FAILED: 'Sorry, we couldn’t load the list of desired industries. Please try again shortly.',
  FETCH_LEADS_DATABASE: 'Sorry, we couldn’t load lead data. Please try again in a few minutes.',
  ADD_RETAILER_FAILED: 'Sorry, we encountered an internal error and couldn’t create the retailer now.',
}
